import { render, staticRenderFns } from "./AmericasmedicalcityCarater.vue?vue&type=template&id=054cc034&scoped=true"
import script from "./AmericasmedicalcityCarater.vue?vue&type=script&lang=ts"
export * from "./AmericasmedicalcityCarater.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054cc034",
  null
  
)

export default component.exports